import { createContext } from 'react';
import { ReactReduxContextValue } from 'react-redux';
import { FloorPlanProviderState } from './store';

export const FloorplanStateContext = createContext<ReactReduxContextValue<FloorPlanProviderState>>(undefined);

export const WebViewFloorplanStateContext = createContext<ReactReduxContextValue<FloorPlanProviderState>>(undefined);
